export function toDateKey(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function buildMonthGrid(year, monthIndex) {
    const firstOfMonth = new Date(year, monthIndex, 1);
    const startDay = firstOfMonth.getDay();
    const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
    const daysInPrevMonth = new Date(year, monthIndex, 0).getDate();

    const cells = [];

    for (let i = startDay - 1; i >= 0; i--) {
        cells.push({ date: new Date(year, monthIndex - 1, daysInPrevMonth - i), isCurrentMonth: false });
    }
    for (let day = 1; day <= daysInMonth; day++) {
        cells.push({ date: new Date(year, monthIndex, day), isCurrentMonth: true });
    }
    while (cells.length % 7 !== 0) {
        const lastDate = cells[cells.length - 1].date;
        cells.push({ date: new Date(lastDate.getFullYear(), lastDate.getMonth(), lastDate.getDate() + 1), isCurrentMonth: false });
    }

    return cells;
}

// Keeps the day of month when moving to another month, clamping to that month's last day.
export function moveToMonth(dateKey, year, monthIndex) {
    const dayOfMonth = Number(dateKey.split('-')[2]);
    const lastDay = new Date(year, monthIndex + 1, 0).getDate();
    return toDateKey(new Date(year, monthIndex, Math.min(dayOfMonth, lastDay)));
}
